import { render, staticRenderFns } from "./HSK.vue?vue&type=template&id=33d6eb58&scoped=true&"
import script from "./HSK.vue?vue&type=script&lang=js&"
export * from "./HSK.vue?vue&type=script&lang=js&"
import style0 from "./HSK.vue?vue&type=style&index=0&id=33d6eb58&lang=scss&scoped=true&"
import style1 from "./HSK.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d6eb58",
  null
  
)

export default component.exports